import React, { useContext } from "react";

import { QuizContext } from "../../layouts/Main";
import Topic from "../Topic/Topic";

import "./Home.css";

const Home = () => {
  const quizz = useContext(QuizContext);

  return (
    <div className="home-container">
      <div className="title-container">
        <h2 className="text-center text-5xl font-bold text-white relative top-20">
          Welcome to Quick Quiz
        </h2>
        <p className="text-center text-lg font-bold text-amber-400 relative top-28">
          Learn programming through Quiz <br />
          and develop your skills
        </p>
      </div>
      <div className="md:flex md:gap-14 ml-20 mr-20 mt-64 mb-96 topics-container ">
        {quizz.data.map((quiz) => (
          <Topic key={quiz.id} quiz={quiz}></Topic>
        ))}
      </div>
    </div>
  );
};

export default Home;
